module.exports = __webpack_public_path__ + "b84444bf8d98e48c8b0055e54071d918.svg";